<template>
  <div class="filter-hide">
    <div class="filter-container container">
      <div class="filter-block">
        <div class="container">
          <span class="hidefilter">
            {{mess.filterTitle}}
            <span class="close_filter" @click="$emit('togleFilter')"></span>
          </span>
          <form id="form_filter" :ref="'form_filter'" :name="obData.arResult.FILTER_NAME+'_form'" :action="obData.arResult.FORM_ACTION" method="get" class="smartfilter">
            <input v-for="hiddenF in obData.arResult.HIDDEN" type="hidden" :name="hiddenF.CONTROL_NAME" :id="hiddenF.CONTROL_ID" :value="hiddenF.HTML_VALUE" />

            <div class="filter-hide-in">
              <div class="filter-tit-top">
                <div class="filter-tit-right">
                  {{obData.arResult.messages.filterTitleRight}}
                </div>
                <div class="filter-tit-name">
                  {{obData.arResult.messages.filterTitle}}
                </div>
                <div class="close-filt" @click="$emit('togleFilter')"></div>
              </div>
              <catalog-filter-block
                  v-for="(filterProp, i) in obData.arResult.ITEMS"
                  :key="i"
                  :result="filterProp"
                  :mess="obData.arResult.messages"
                  :active-control-id="activeControlId"
                  :found-count="foundCount"
                  :apply-link="applyLink"
                  :show-price-slider-plashka="showPriceSliderPlashka"
                  :plashka-loading="plashkaLoading"
                  @setFilter="setFilter"
                  @setSearch="setSearch"
                  @clearfilter="clearfilter"
              />
            </div>


            <div class="filter-btns">
              <div class="filter-do-btn">
                <div class="filter-act">
                  <!--
                  <a :href="obData.arResult.SEF_SET_FILTER_URL" :class="'def-bt '+(obData.arResult.SEF_SET_FILTER_URL!==obData.arResult.SEF_DEL_FILTER_URL?'':'disable')">
                    {{obData.arResult.messages.filterApply}}
                  </a>
                  -->
                  <a @click="clearfilter($event)" :href="obData.arResult.SEF_DEL_FILTER_URL" :class="'border-bt canc '+(obData.arResult.SEF_SET_FILTER_URL==obData.arResult.SEF_DEL_FILTER_URL?'disable':'')"  >
                    {{obData.arResult.messages.filterClear}}
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CatalogFilterBlock from "./block.vue";

export default {
  name: "catalog-filter",
  components: {CatalogFilterBlock},
  selector: 'catalog-filter',
  props:["params","mess","reset_without_prop"],
  data() {
    return {
      obData:this.params,
      priceSlider:{},
      setedFilter:false,
      hidingTooltipSlider:false,
      activeControlId: null,
      foundCount: 0,
      applyLink: '#',
      showPriceSliderPlashka: false,
      plashkaLoading: false
    }
  },
  watch: {
    reset_without_prop() {
      this.setFilter().then(() => {
        location.href = this.obData.arResult.FILTER_URL;
      });
    }
  },
  methods:{
    clearfilter:function (event) {
      location.href=this.obData.arResult.SEF_DEL_FILTER_URL;
      if(event) {
        event.preventDefault();
      }
    },
    setSearch(searchParams) {
      let inputValue = searchParams.q;
      inputValue = inputValue.toUpperCase();
      for(let k in this.obData.arResult.ITEMS) {
        if(this.obData.arResult.ITEMS[k].ID===searchParams.id) {
          for(let key in this.obData.arResult.ITEMS[k].VALUES) {
            let curVal = this.obData.arResult.ITEMS[k].VALUES[key].VALUE.toUpperCase();
            let hide = false;
            if(curVal.indexOf(inputValue) === -1 && inputValue!=="") {
              hide = true;
            }
            this.obData.arResult.ITEMS[k].VALUES[key].hidden = hide;
          }
        }
      }
    },
    setFilter: async function (payload) {
      if (payload && payload.CONTROL_ID) {
        this.activeControlId = payload.CONTROL_ID;
        this.showPriceSliderPlashka = false;
        this.plashkaLoading = true;
      } else if (payload && payload.isPriceSlider) {
        this.activeControlId = null;
        this.showPriceSliderPlashka = true;
        this.plashkaLoading = true;
      } else {
        this.activeControlId = null;
        this.showPriceSliderPlashka = false;
      }

      let formData = new FormData(this.$refs['form_filter']);
      formData.append('ajax', 'y');

      if (this.reset_without_prop) {
        if (Array.isArray(this.reset_without_prop)) {
          this.reset_without_prop.forEach(function(item, i, arr) {
            formData.delete(item);
          });
        } else {
          formData.delete(this.reset_without_prop);
        }
      }

      formData = Object.fromEntries(formData);
      for (let k in formData) {
        if (formData[k] === "") {
          delete formData[k];
        }
      }

      try {
        const response = await axios.post(this.obData.arResult.FILTER_AJAX_URL, formData);
        if (response.status === 200) {
          this.obData.arResult = response.data;
          this.foundCount = this.obData.arResult.ELEMENT_COUNT;
          this.applyLink = this.obData.arResult.SEF_SET_FILTER_URL;
          setTimeout(() => {
            this.plashkaLoading = false;
          }, 1000);
        }
      } catch (e) {
        this.plashkaLoading = false;
        this.activeControlId = null;
        this.showPriceSliderPlashka = false;
      }
    },
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
  .filter-hide {
    float: none;
    width: 100%;
    height: 1px;
    padding: 0;
    top: 0px;
    @media (max-width: 992px) {
      position: absolute;
      //left: -25px;
    }
    .hidefilter {
      position: relative;
      .close_filter {
        background: url('data:image/png;base64,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');
        display: inline-block;
        width: 18px;
        height: 18px;
        background-size: contain;
        position: absolute;
        right: 5px;
        top: 50%;
        margin-top: -9px;
        cursor: pointer;
      }
    }
    .filter-container {
      height: 1px;
      .filter-block {
        max-width: 350px;
        background: #f7f7f7;
        margin-top: 2px;
        .filter-hide-in {
          float: none;
          @media (max-width: 992px) {
            padding-top: 0px;
            padding-right: 15px
          }
        .one-filter {
          float: none;
          width: 100%;
        }
      }
      .hidefilter {
        display: inline-block;
        width: 100%;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
  }
}
.opened-filter {
  .filter-hide {
    display: block;
  }
}
.filter-btns {
  float: none;
  .filter-do-btn {
    float: none;
    @media (max-width: 992px) {
      position: relative;
    }
    .filter-act{
      float: none;
      .def-bt {
        float: none;
        width: 100%;
        display: block;
        margin: 0 auto;
      }
      .border-bt.canc {
        float: none;
        display: inline-block;
        margin: 0;
        margin-top: 10px;
        margin-bottom: 20px;
        width: 100%;
        @media (max-width: 992px) {
          display: inline-block!important;
        }

      }
    }
  }
}
@media (max-width: 768px) {
  .filter-hide {
    .filter-container {
      .filter-block {
        max-width: 100%;
        padding: 0 10px;
      }
    }
  }
}

</style>